<template>
	<div class="insert">
		<div class="title">就诊流程_样本入库</div>
		<div class="handle-header">
			<div class="handle-name">
				测序中心：
				<span>康圣达</span>
			</div>
			<div class="handle-select">
				<span class="handle-select-name">流转机构：</span>
				<span :class="{'has-error':isSubmit&&!value}" class="handle-select-object">
          <!-- <a-tree-select
            style="width: 162px"
            :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择流转机构"
            allowClear
            treeDefaultExpandAll
          >
            <a-tree-select-node value="parent 1" title="parent 1" key="0-1">
              <a-tree-select-node value="parent 1-0" title="parent 1-0" key="0-1-1">
                <a-tree-select-node :selectable="false" value="leaf1" title="my leaf" key="random" />
                <a-tree-select-node value="leaf2" title="your leaf" key="random1" />
              </a-tree-select-node>
              <a-tree-select-node value="parent 1-1" title="parent 1-1" key="random2">
                <a-tree-select-node value="sss" key="random3">
                  <b style="color: #08c" slot="title">sss</b>
                </a-tree-select-node>
              </a-tree-select-node>
            </a-tree-select-node>
          </a-tree-select>-->
          <a-tree-select
		          style="width: 100%"
		          :value="value"
		          :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
		          placeholder="请选择"
		          allowClear
		          treeDefaultExpandAll
		          :getPopupContainer="triggerNode => triggerNode.parentNode"
		          @change="onChange"
          >
            <a-tree-select-node
		            v-for="(item) in treeExpandedKeys"
		            :selectable="false"
		            :value="item.deptId+''"
		            :title="item.deptName"
		            :key="item.deptId"
            >
              <a-tree-select-node
		              v-for="(cItem) in item.children"
		              :value="cItem.deptId+''"
		              :title="cItem.deptName"
		              :key="cItem.deptId"
              />
            </a-tree-select-node>
          </a-tree-select>
        </span>
			</div>
		</div>
		<a-table class="hospital-table" size="middle" :pagination="false" :dataSource="data">
			<a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
				<span class="table-th" slot="title">序号</span>
			</a-table-column>
			<a-table-column :width="130" data-index="hosBarCode" key="hosBarCode">
				<span class="hospital-required table-th" slot="title">协作组条码</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.hosBarCode}">
						<a-input
								placeholder="请输入协作组条码"
								:disabled="true"
								style="margin: -5px 0;width: 130px"
								v-model="record.hosBarCode"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="barCode" key="barCode">
				<span class="table-th hospital-required" slot="title">测序中心条码</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.barCode}">
						<a-input
								placeholder="请输入测序中心条码"
								:disabled="true"
								style="margin: -5px 0;width: 130px"
								v-model="record.barCode"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="100" data-index="applyItemName" key="applyItemName">
				<span class="table-th" slot="title">检测项目</span>
				<template slot-scope="text, record,index">
					<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width: 100px" v-model="record.applyItemName" :disabled="true">
						<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
						<a-select-option
								v-for="item in applyItems"
								:key="item.dictKey"
								:value="item.dictKey+''"
						>{{item.dictValue}}
						</a-select-option>
					</a-select>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="groupName" key="groupName">
				<span class="table-th" slot="title">专业组</span>
				<template slot-scope="text, record">
					<a-input
							:disabled="true"
							style="margin: -5px 0;width: 130px"
							v-model="record.groupName"
					/>
				</template>
			</a-table-column>
			<a-table-column :width="100" data-index="sampleTypeName" key="sampleTypeName">
				<span class="table-th hospital-required" slot="title">样本类型</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.status&&!record.sampleTypeName}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:100px" v-model="record.sampleTypeName" placeholder="请选择样本类型">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option
									v-for="item in sampleTypes"
									:key="item.dictKey"
									:value="item.dictKey+''"
							>{{item.dictValue}}
							</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="sampleAmount" key="sampleAmount">
				<span class="table-th hospital-required" slot="title">样本量（ml）</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!isOkNum(record.sampleAmount)}">
						<a-input style="width:130px" v-model="record.sampleAmount" placeholder="输入标本量（ml）"/>
					</div>
				</template>
			</a-table-column>
		</a-table>
		<div class="footer">
			<a-button :loading="btnloading" @click="submitData" style="width:680px" type="primary">确认</a-button>
		</div>
	</div>
</template>

<script>
  import {regAll} from "../../common/validate";

  export default {
    props: {
      list: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        data: [],
        applyItems: [],
        sampleTypes: [],
        treeExpandedKeys: [],
        isSubmit: false,
        value: null,
        btnloading: false,
        isHttpSubmit: false
      };
    },
    mounted() {
      this.list.forEach((item, index) => {
        item.status = false;
        if (!item.sampleTypeName) {
          item.sampleTypeName = undefined;
        }
        if (!item.applyItemName) {
          item.applyItemName = undefined;
        }
      });
      this.data = this.list;
      // this.data.splice(this.list.length);
      this.getDirt("sampleType").then(data => {
        this.sampleTypes = data.rows;
      });
      this.getDirt("applyItem").then(data => {
        this.applyItems = data.rows;
      });
      this.getOrgan();
    },
    methods: {
      onChange(value) {
        this.value = value;
      },
      isOkNum(num) {
        if (num) {
          if (!regAll.regNum2.test(num)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      },
      submitData() {
        this.data.forEach(item => {
          item.status = true;
        });
        this.isSubmit = true;
        this.$nextTick(() => {
          var errList = document.querySelectorAll(".has-error");
          if (errList.length == 0) {
            this.data.forEach(item => {
              item.deptId = this.value;
            });
            this.btnloading = true;
            this.$post("sampleinfo?infoFrom=patientItem", this.data, {
              "Content-Type": "application/json"
            }).then(res => {
              if (res.data.code == 1) {
                this.$message.success("标本入库成功！");
                this.$emit("close");
                this.btnloading = false;
              } else {
                this.$message.error(res.data.message);
                this.btnloading = false;
              }
              // if (res.data.data) {
              //   this.$message.success("标本入库成功！");
              //   this.$emit("close");
              // } else {
              //   this.$message.error(res.data.message);
              // }
            });
          }
        });
        // this.$post('sampleinfo/putBatch');
      },
      getDirt(dictType) {
        return new Promise((resolve, reject) => {
          this.$get("info/commonDict", {
            dictType: dictType,
            pageSize: 10000
          }).then(
            res => {
              resolve(res.data.data);
            },
            err => {
              reject(err);
            }
          );
        });
      },
      getOrgan() {
        this.$get("dept/findDeptTreeList").then(
          res => {
            this.treeExpandedKeys = res.data.data;
          },
          err => {
            console.log("err", err);
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
	.insert {
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			padding-top: 82px;
		}
		.handle-header {
			background: rgba(249, 251, 251, 1);
			border: 1px solid rgba(240, 242, 245, 1);
			padding: 0 20px;
			line-height: 56px;
			margin-top: 40px;
			height: 56px;
			width: 100%;
			margin-bottom: 30px;
			.handle-name {
				float: left;
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
			}
			.handle-select {
				float: left;
				margin-left: 180px;
			}
			/deep/ .handle-select-object {
				width: 160px;
				position: relative;
				height: 37px;
				display: inline-block;
				.ant-select {
					position: absolute;
					width: 100%;
					top: 12px;
				}
			}
			.handle-select-name {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
			}
		}
		.footer {
			padding: 40px 0;
			text-align: center;
		}
	}
</style>